<div *ngIf="filters.length > 0" class="split-selected-filters-chips flex flex-wrap gap-2 pt-2">
  <button
    *ngIf="showClearAll"
    type="button"
    pButton
    class="split-selected-filters-chips__clear p-button-text p-button-sm"
    label="Limpar tudo"
    (click)="onClearAll()">
  </button>

  <p-chip
    *ngFor="let chip of filters; trackBy: trackByKey"
    [label]="chip.label + ': ' + chip.displayValue"
    [removable]="true"
    (onRemove)="onRemove(chip)"
    styleClass="split-filter-chip">
  </p-chip>
</div>
